if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      // Find the product section and the ATC button dynamically
      this.productSection = this.closest('.cc-main-product');
      this.productForm = this.productSection ? this.productSection.querySelector('product-form') : null;
      this.atcButton = this.productForm ? this.productForm.querySelector('button[type="submit"]') : null;

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // Cleanup on disconnect
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      // Observe the ATC button visibility
      if (this.atcButton) {
        const atcButtonObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // ATC button is visible, hide the sticky panel
                this.classList.add('sticky-atc-panel--out');
              } else {
                // ATC button is not visible, show the sticky panel
                this.classList.remove('sticky-atc-panel--out');
              }
            });
          },
          {
            threshold: 0.5, // Adjust the threshold as needed
          }
        );

        atcButtonObserver.observe(this.atcButton);
      }

      // Handle scroll to the bottom of the page
      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}